module.exports = __webpack_public_path__ + "img/icn_back_to_app.15ba2d87.svg";